export default "<h1>Type1Base list</h1>\n<spec-app-type1-base-table [clickHandler]=\"createClickHandler()\"></spec-app-type1-base-table>";